import { Path } from "../constants/routes"
import { upperFirst } from "lodash"
import { NavigationLink } from "../types/navigation-link.interface"

const normalizeUrl = (url: string | Path): string => {
  let normalizedUrl = url.toString()
  if (normalizedUrl.startsWith("/")) {
    normalizedUrl = normalizedUrl.slice(1)
  }
  if (normalizedUrl.endsWith("/")) {
    normalizedUrl = normalizedUrl.slice(0, normalizedUrl.length - 1)
  }
  return normalizedUrl
}

const getPathParts = (url: string | Path): string[] => {
  const normalizedUrl = normalizeUrl(url)
  return normalizedUrl.split("/")
}

const getBreadcrumbPath = (urlParts: string[], index: number) => {
  // "/" at the beginning is necessary here!
  return "/" + urlParts.slice(0, index + 1).join("/")
}

const getBreadcrumbTitle = (urlPart: string) => {
  const split = urlPart.split("-")
  const upper = split.map((word) => upperFirst(word))
  return upper.join(" ")
}

export const mapUrlToBreadcrumbs = (
  url: string | Path,
  customTitles?: Record<string, string | null> | null
): NavigationLink[] => {
  const parts = getPathParts(url)

  return parts.map((part, index) => {
    const url = getBreadcrumbPath(parts, index)
    const normalizedUrl = normalizeUrl(url)
    const customTitle = customTitles && customTitles[normalizedUrl]

    return {
      title: customTitle || getBreadcrumbTitle(part),
      url,
    }
  })
}
